const createFormData = (formValues) => {
    const objectKeys = Object.keys(formValues);
    let formData = new FormData();
    
    objectKeys.forEach(key => {
        if (key === "image" && typeof formValues[key] !== "string"){
            formData.append(key, formValues[key], formValues[key].name);
        }
        else if(Array.isArray(formValues[key])){
            formValues[key].forEach(value => formData.append(key + '[]', value))
        }
        else{
            formData.append(key, formValues[key])
        }
    })
  
    return formData;
  }

  export default createFormData;